module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_6000.41251112.png";